import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

const useWizardForm = ({ resolver, defaultValues } = {}) => {
  const [formState, setFormState] = useState({});
  const [hideButtons, setHideButtons] = useState(false);

  const {
    register,
    setValue,
    watch,
    control,
    resetField,
    setError,
    clearErrors,
    formState: { errors, isDirty },
    handleSubmit,
    trigger,
  } = useForm({
    ...(defaultValues && { defaultValues }),
    mode: 'onChange',
    resolver,
  });

  useEffect(() => {
    trigger();
  }, [trigger]);

  const wrapperProps = {
    register,
    setValue,
    watch,
    control,
    resetField,
    setError,
    clearErrors,
    errors,
    handleSubmit,
    trigger,
    formState,
    setFormState,
    hideButtons,
    isFormDirty: isDirty,
  };

  return {
    register,
    setValue,
    watch,
    control,
    resetField,
    setError,
    clearErrors,
    errors,
    isDirty,
    handleSubmit,
    trigger,
    formState,
    setFormState,
    hideButtons,
    setHideButtons,
    wrapperProps,
  };
};

export default useWizardForm;
